import React from 'react'
import SalesList from './List'
import { Layout } from 'antd'
import Header from '../Header'

const { Content } = Layout


const Sales = (props) => {
  return (
    <Layout className='layout'>
      <Header item='sales' />
      <Content style={{ padding: '0 50px' }}>
        <div className='content-auto'>
          <SalesList />
        </div>
      </Content>
    </Layout>
  )
}

export default Sales
